import React, { useState, useRef } from "react";
import { MessageCircle } from "react-feather";

function Whatsapp() {
  const message = encodeURIComponent("Hello! I would like to ");
  const phone = "919711226555"; // Replace with the desired phone number in international format (no +)
  const whatsappURL = `https://wa.me/${phone}?text=${message}`;

  const [position, setPosition] = useState({ x: window.innerWidth - 80, y: window.innerHeight - 80 });
  const dragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const iconRef = useRef(null);

  const openWhatsApp = () => {
    window.open(whatsappURL, "_blank");
  };

  const onMouseDown = (e) => {
    dragging.current = true;
    dragStart.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
    e.preventDefault();
  };

  const onMouseMove = (e) => {
    if (dragging.current) {
      let newX = e.clientX - dragStart.current.x;
      let newY = e.clientY - dragStart.current.y;

      // Optional: boundary checks to keep icon inside viewport
      const icon = iconRef.current;
      if (icon) {
        const maxX = window.innerWidth - icon.offsetWidth;
        const maxY = window.innerHeight - icon.offsetHeight;

        newX = Math.min(Math.max(0, newX), maxX);
        newY = Math.min(Math.max(0, newY), maxY);
      }

      setPosition({ x: newX, y: newY });
    }
  };

  const onMouseUp = () => {
    dragging.current = false;
  };

  return (
    <div
      ref={iconRef}
      onClick={openWhatsApp}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
      style={{
        position: "fixed",
        right: position.x,
        top: position.y,
        zIndex: 1000,
        backgroundColor: "#25D366",
        color: "white",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: dragging.current ? "grabbing" : "grab",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        userSelect: "none",
        touchAction: "none",
      }}
      title="Chat on WhatsApp"
    >
      <MessageCircle size={28} />
    </div>
  );
}

export default Whatsapp;
